import React from 'react';
import { Colors } from '@common/tokens';
import { Col, Form, Row } from 'antd';
import { isMileagePayCode } from '@pay-bill/services';

export const DisputeDiffSectionLabels = ({
  mode,
}: {
  mode: 'form' | 'missing-line-form' | 'view';
}) => {
  const selectedPayCode = Form.useWatch('newPayCode');
  const hoursLabel = isMileagePayCode(selectedPayCode) ? 'Quantity' : 'Hours';

  const renderRequired = () =>
    mode !== 'view' ? <span className="required-field">* </span> : null;

  return (
    <div className="DisputeDiffSectionLabels">
      <div className="table-row">
        <Row gutter={[16, 0]}>
          <Col span={6}>
            <span className="table-label">{renderRequired()}Pay Code</span>
          </Col>
          <Col span={6}>
            <span className="table-label">Billing Rate</span>
          </Col>
          <Col span={6}>
            <span className="table-label">
              {renderRequired()}
              {hoursLabel}
            </span>
          </Col>
          <Col span={6}>
            <span className="table-label">Billing Amount</span>
          </Col>
        </Row>
      </div>
      <style jsx>
        {`
          :global(.DisputeDiffSectionLabels .required-field) {
            color: ${Colors.coral};
          }
          .DisputeDiffSectionLabels .table-label {
            font-weight: ${mode === 'missing-line-form' ? 600 : 900};
          }
        `}
      </style>
    </div>
  );
};
